// extracted by mini-css-extract-plugin
export default {"aboutme":"AboutMe_aboutme__i2r88","header":"AboutMe_header__3B7bG","learning":"AboutMe_learning__PFhz4","text":"AboutMe_text__xcntm"};